import getCategoriesApi from '../api';
import { getIcon } from '../categories.utils';
import { actions } from './categories.slice';
import { Category } from './types';

const getCategories = () => async (dispatch: any) => {
  try {
    const { groups, categories: categoriesDto } = await getCategoriesApi();
    const categories: Category[] = categoriesDto.map(dto => {
      const icon = getIcon(dto);
      return { ...dto, icon };
    });
    dispatch(actions.getCategoriesSuccess({ groups, categories }));
  } catch (_e) {
    dispatch(actions.getCategoriesFailed());
  }
};

export default getCategories;
